import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { TemplateIncaComponent } from './layout/template-inca/template-inca.component';
import { homeComponent } from './views/home/home.component';
import { CadastroComponent } from './views/cadastro/cadastro.component';
import { AdministraComponent } from './views/administra/administra.component';
import { AnaliseComponent } from './views/analise/analise.component';
import { ComunicacaoComponent } from './views/comunicacao/comunicacao.component';
import { UploadComponent } from './views/upload/upload.component';
import { RevisaoComponent } from './views/revisao/revisao.component';
import { UploadrevisaoComponent } from './views/uploadrevisao/uploadrevisao.component';
import { AcessoComponent } from './views/acesso/acesso.component';
import { MenuComponent } from './views/menu/menu.component';
import { AlterarComponent } from './views/alterar/alterar.component';
import { ExcluirComponent } from './views/excluir/excluir.component';
import { IncluirComponent } from './views/incluir/incluir.component';
import { InscricaoComponent } from './views/inscricao/inscricao.component';
const routes: Routes = [
  {
    path: '',
    component: TemplateIncaComponent,
    children: [
      {
        path: '',
        component: homeComponent
      },
      {
        path: 'cadastro',
        component: CadastroComponent,
      },
      {
        path: 'administra',
        component: AdministraComponent,
      },
      {
        path: 'analise',
        component: AnaliseComponent,
      },
      {
        path: 'acesso',
        component: AcessoComponent,
      },
      {
        path: 'menu',
        component: MenuComponent,
      },
      {
        path: 'incluir',
        component: IncluirComponent,
      },
      {
        path: 'inscricao',
        component: InscricaoComponent,
      },      
      {
        path: 'alterar',
        component: AlterarComponent,
      },
      {
        path: 'excluir',
        component: ExcluirComponent,
      },
      {
        path: 'upload',
        component: UploadComponent,
      },
      {
        path: 'revisao',
        component: RevisaoComponent,
      },
      {
        path: 'uploadrevisao',
        component: UploadrevisaoComponent,
      },

    ]
  }
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {

}
